import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, FormSection, Form } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { required, MultiselectView, MultiInput, ParkingFilter2, StyledField, DarkMultiselect, HorizontalMultiselect } from 'libs/form';
import { useUiVersion } from 'hooks';
import { Tarrificator } from '../tarifficators/tarifficator';
import { FormHeader, SaveButton, TariffData } from '../../styledComponents';
import { SectionTitle, TwoFields } from './tariff-form-main.styled';
import { validate } from '../validation';

const NewTariffFormForm = (props) => {
  const { onSubmit, vehicleClasses, categories, tarrificatorParams /*, initialize, resetn*/ } = props;
  const { t } = useTranslation();
  const { isNew } = useUiVersion();
  const Multiselect = isNew ? HorizontalMultiselect : DarkMultiselect;
  const validateP = useCallback(required(t), [t]);

  // useEffect(() => {
  // resetForm();
  // initialize(props.initialValues);
  // }, [resetn]);

  // const minValue1 = minValue(t, 1);
  // const maxValue99 = maxValue(t, 99);
  const timeLimit = props.initialValues.time_limit;
  const withTimeLimit = timeLimit !== undefined && timeLimit !== null;

  return (
    <Form onSubmit={props.handleSubmit(onSubmit)}>
      <TariffData>
        <FormHeader>{t('form.Данные тарифа')}</FormHeader>

        <StyledField type="select" label={t('dict_filter.Тип')} name="type" disabled={true} className="disabled">
          <option value="individual">{t('grid.Индивидуальный')}</option>
        </StyledField>
        <ParkingFilter2 dark />
        <StyledField validate={validateP} placeholder={t('grid.Осень 2017')} type="text" label={t('grid.Название *')} name="name" />
        <Multiselect
          validate={validateP}
          type="multiselect"
          label={t('form.Класс ТС *')}
          name="vehicle_class"
          placeholder={t('form.Выберите класс ТС')}
          data={vehicleClasses}
          additionalComponent={isNew ? MultiInput : MultiselectView}
          autoWidth={false}
        />
        <Multiselect
          // validate={validateP}
          type="multiselect"
          label={t('form.Категория')}
          name="vehicle_category"
          placeholder={t('form.Выберите категорию ТС')}
          data={categories}
          additionalComponent={isNew ? MultiInput : MultiselectView}
          autoWidth={false}
        />
        <StyledField className="shortfield" validate={validateP} placeholder={t('form.08 11 2017')} type="dateTime" label={t('grid.Начало *')} name="time_from" />

        <StyledField type="text" placeholder={t('form.15 мин')} label={t('form.Время на выезд')} name="time_to_leave" mask={{ suffix: t('form.мин') }} />

        <SectionTitle>{t('sections.Абонемент')}</SectionTitle>
        <StyledField type="text" placeholder={t('form.Цена абонемента')} label={t('form.Цена абонемента')} name="subscription_amount" mask={{ suffix: t('form.руб') }} />
        <TwoFields>
          <StyledField type="text" placeholder={'30'} label={t('form.Срок действия')} name="subscription_period" naturalNumber />
          <StyledField type="select" label="" name="subscription_period_unit" onlyInput>
            <option value="days">{t('units.дней')}</option>
            <option value="months">{t('units.месяцев')}</option>
          </StyledField>
        </TwoFields>
        {withTimeLimit && (
          <StyledField type="text" placeholder={t('form.15 мин')} label={t('form.Лимит времени')} name="time_limit" mask={{ suffix: t('form.мин') }} naturalNumber />
        )}

        <SectionTitle>{t('form.Повторный въезд')}</SectionTitle>
        <StyledField
          type="text"
          placeholder={t('form.15 мин')}
          label={t('form.Повторный платный въезд')}
          name="secondentry_interval"
          mask={{ suffix: t('form.мин') }}
          naturalNumber
          // min={1}
          // max={99}
          // validate={[minValue1, maxValue99]}
        />
      </TariffData>

      <FormSection name="zones">
        <Tarrificator {...tarrificatorParams} />
      </FormSection>

      <SaveButton disabled={props.submitting} />
    </Form>
  );
};

NewTariffFormForm.propTypes = {
  onSubmit: PropTypes.any.isRequired,
  initialValues: PropTypes.any.isRequired,
  tarrificatorParams: PropTypes.any.isRequired,
  categories: PropTypes.any.isRequired,
  vehicleClasses: PropTypes.any.isRequired,
  handleSubmit: PropTypes.any.isRequired,
};

export const NewTariffForm = reduxForm({
  form: 'newTariffForm',
  // initialValues,
  validate,
  // enableReinitialize: true,
})(NewTariffFormForm);
